module.exports = __webpack_public_path__ + "media/warranty-claim/warranty_claim_overview_thumbnail-b51283de.png";